import request from "@/utils/request";

export function selectPageList(data) {
  return request({
    url: "/test/reportEmergencyBrake/selectPageList",
    method: "post",
    data: data,
  });
}

export function detail(data) {
  return request({
    url: "/test/reportEmergencyBrake/detail",
    method: "post",
    data: data,
  });
}

export function editOne(data) {
  return request({
    url: "/test/reportEmergencyBrake/editOne",
    method: "post",
    data: data,
  });
}

export function deleteBatch(data) {
  return request({
    url: "/test/reportEmergencyBrake/deleteBatch",
    method: "post",
    data: data,
  });
}

export function insertOne(data) {
    return request({
      url: "/test/reportEmergencyBrake/insertOne",
      method: "post",
      data: data,
    });
}

export function getHistoryVideos(data) {
  return request({
    url: "/test/reportEmergencyBrake/historyVideos",
    method: "post",
    data: data,
  });
}

export function download(data) {
  return request({
    url: "/test/reportEmergencyBrake/download",
    method: "post",
    data: data,
    responseType: 'blob' // 设置响应类型为blob
  }).then(res => {
    // 处理返回的blob数据
    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });

    // 创建下载链接
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // 设置文件名，这里可以从响应头获取，或者使用默认名
    const contentDisposition = res.headers?.['Content-Disposition'];
    let fileName = '智能网联汽车开放道路测试急刹报告.docx';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^;"]+)"?/);
      if (match && match[1]) {
        fileName = decodeURIComponent(match[1]);
      }
    }

    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // 清理
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
  }).catch(error => {
    console.error('下载文件失败:', error);
    return { success: false, error };
  });
}
  